import React, { Component } from 'react';
import { Modal } from 'react-router-modal';
import withEscClose from '../../common/components/withEscClose';
import { ModalContentBlock } from '../../pages/components';
import { Form, Label, Select, LabelInput } from '../../common/components/form';
import Button from '../../../ui/button/Button';
import styled from 'styled-components'; // Used for Wrapper class
import { Localize } from '../../../locale/localization';

const CloseableModal = withEscClose(Modal);

//#region styles
const Wrapper = styled.div`
  text-align: center;
  box-sizing: border-box;
  margin: auto 1rem;
  width: 100%;

  label {
    margin-top: 2rem;
  }

  li {
    padding-top: 0.5rem;
  }
`;

const Spacer = styled.div`
  width: 100%;
  height: 1rem;
`;
//#endregion

class UserControl extends Component {
  initialState = {
    selectedRegion: '',
    selectedTeam: '',
    selectedRole: '',
    selectedAdminRole: '',
    setAdmin: '',
    selectedView: '',
  };

  constructor(props) {
    super(props);
    this.state = this.initialState;
  }

  //#region form
  /* ############# */
  /* FORM HANDLING */
  /* ############# */
  handleRegionChange(e) {
    this.setState({ selectedRegion: e.target.value });
  }

  handleTeamChange(e) {
    this.setState({ selectedTeam: e.target.value });
  }

  handleRoleChange(e) {
    /* Update Role state after pulldown menu selection */
    const id = e.target.value;

    switch (id) {
      case 'regionmanager':
        this.setState({
          selectedRole: id,
          setAdmin: '2',
          selectedTeam: '',
        });
        break;

      case 'salesmanager':
        this.setState({
          selectedRole: id,
          setAdmin: '3',
          selectedTeam: '',
          selectedRegion: '',
        });
        break;

      default:
        this.setState({
          selectedRole: id,
          setAdmin: '',
        });
        break;
    }
  }

  handleAdminChange(e) {
    /* Update Role state after pulldown menu selection */
    const id = e.target.value;

    if (id === 'teamlead') {
      this.setState({
        selectedAdminRole: id,
        setAdmin: '1',
        selectedRole: '',
      });
    } else if (id === 'regionmanager') {
      this.setState({
        selectedAdminRole: id,
        setAdmin: '2',
        selectedRole: '',
        selectedTeam: '',
      });
    } else if (id === 'salesmanager') {
      this.setState({
        selectedAdminRole: id,
        setAdmin: '3',
        selectedRole: '',
        selectedTeam: '',
        selectedRegion: '',
      });
    } else {
      this.setState({
        selectedAdminRole: '',
        setAdmin: '',
      });
    }
  }
  //#endregion

  //#region functionalities
  /* ############### */
  /* FUNCTIONALITIES */
  /* ############### */
  /* Delete functionalities */
  confirmDelete = user => {
    const { deleteUser } = this.props;

    const onDelete = () => {
      this.resetView();
    };

    const { id } = user; // here "entity" is not the user object but a string: user/team/region/channel
    /* TODO: Make it possible to delete channels! */
    deleteUser(id).then(onDelete);
  };

  prepareUpdateData = (admin, entity) => {
    const { region, team, role, channel } = this.getValuesFromStateOrProps();
    let updateData = {
      _id: entity._id,
      role: entity.role,
    };
    let updateAdmin = {};
    let hasTeam = false;
    let promotion = false;
    let demotionError = false;

    if (admin) {
      /* Handle take over on adminUser in team/region/chanel  */
      switch (admin) {
        case 'salesmanager':
          /* Data for CHANNEL update */
          updateAdmin._id = channel._id;
          updateAdmin.adminUser = entity._id;

          /* Data for USER update */
          updateData.role = admin;
          updateData.region = null;
          updateData.team = null;
          updateData.role !== (undefined && null) ? (promotion = true) : (demotionError = true);
          break;

        case 'regionmanager':
          /* Data for CHANNEL update */
          updateAdmin._id = region._id;
          updateAdmin.adminUser = entity._id;

          /* Data for USER update */
          updateData.role = admin;
          updateData.region = region._id;
          updateData.team = null;
          (updateData.role && updateData.region) !== (undefined && null) ? (promotion = true) : (demotionError = true);
          break;

        case 'teamlead':
          /* Data for CHANNEL update */
          updateAdmin._id = team._id;
          updateAdmin.adminUser = entity._id;

          /* Data for USER update */
          updateData.role = admin;
          updateData.region = region._id;
          updateData.team = team._id;
          (updateData.role && updateData.region && updateData.team) !== (undefined && null)
            ? (promotion = true)
            : (demotionError = true);
          break;

        default:
          break;
      }
    } else {
      /* Handle orginal user move and promotion */
      if (region) {
        /* Handle region change */
        updateData.region = region;
        if (team) {
          /* Handle team change */
          updateData.team = team;
          hasTeam = true;
        }
      }

      if (role) {
        /* Handle only promotion */
        switch (role) {
          case 'superuser':
            /* TODO: What role/team/region ADMIN can have?! */
            console.log('ERROR! Superusers cannot be modified');
            break;

          case 'salesmanager':
            updateData.role = role;
            /* No modifying of the CHANNEL because channel(=company) CAN'T change! */
            updateData.region = null;
            updateData.team = null;
            updateData.role !== (undefined && null) ? (promotion = true) : (demotionError = true);
            break;

          case 'regionmanager':
            updateData.role = role;
            updateData.region = hasTeam && region !== (null && undefined) ? region : entity.region;
            updateData.team = null;
            /* Check that required fields are acquired */
            (updateData.role && updateData.region) !== (undefined && null)
              ? (promotion = true)
              : (demotionError = true);
            break;

          case 'teamlead':
            updateData.role = role;
            updateData.region = hasTeam && region !== (null && undefined) ? region : entity.region;
            updateData.team = hasTeam && team !== (null && undefined) ? team : entity.team;
            /* Check that required fields are acquired */
            (updateData.role && updateData.region && updateData.team) !== (undefined && null)
              ? (promotion = true)
              : (demotionError = true);
            break;

          case 'assistant':
          case 'user':
            updateData.role = role;
            updateData.region = hasTeam && region !== (null && undefined) ? region : entity.region;
            updateData.team = hasTeam && team !== (null && undefined) ? team : entity.team;
            /* Check that required fields are acquired */
            (updateData.role && updateData.region && updateData.team) !== (undefined && null)
              ? (promotion = true)
              : (demotionError = true);
            break;

          default:
            console.log('ERROR! Invalid role');
            break;
        }
      }
    }

    return {
      updateData: updateData,
      updateAdmin: updateAdmin,
      promotion: promotion,
      demotionError: demotionError,
      hasTeam: hasTeam,
    };
  };

  /* Transfer functionalities */
  confirmTransfer = user => {
    const { updateUser, updateTeam, updateChannel, updateRegion } = this.props;
    const { admin } = this.getValuesFromStateOrProps();
    const { entity } = user;

    /* Collect data that is going to be updated */
    let { updateData, updateAdmin, hasTeam, promotion, demotionError } = this.prepareUpdateData(admin, entity);

    /* This is for channels that has no region defined but has teams */
    /* region._id comes from user role selection, region comes from user ADMIN role selection */
    if (updateData.region && (updateData.region._id === 'orphan' || updateData.region === 'orphan')) {
      updateData.region = null;
    }

    /* Prevent user demotion from role that had no team to role that needs a team */
    if (this.getRoleNumber(updateData.role) > 3 && !hasTeam) {
      demotionError = true;
    }

    if (!demotionError && (hasTeam || promotion)) {
      /* Do NOT send update if only region is selected and no changes are made for the user role */
      /* Check user role and send update data, then set the "chosen user" state to NULL */

      const onTransfer = () => {
        this.resetView();
      };

      switch (updateData.role) {
        case 'user':
        case 'assistant':
        case 'teamlead':
        case 'regionmanager':
        case 'salesmanager':
        case 'superuser':
          if (admin) {
            if (admin === 'teamlead') {
              const { getTeams } = this.props;
              updateUser(updateData)
                .then(updateTeam(updateAdmin))
                .then(onTransfer)
                .then(getTeams); /* This refresh the team after the adminUser has been modified */
            } else if (admin === 'regionmanager') {
              updateUser(updateData)
                .then(updateRegion(updateAdmin))
                .then(onTransfer);
            } else if (admin === 'salesmanager') {
              /* TODO: This is not implemented yet!!! -- IMPLEMENT THIS */
              updateUser(updateData)
                .then(updateChannel(updateAdmin))
                .then(onTransfer);
            }
          } else {
            updateUser(updateData).then(onTransfer);
          }
          break;
        default:
          console.log('User role Unknown');
      }
    } else {
      console.log('Invalid transform info!');
    }
  };

  onCopyRegistrationLink = () => {
    const { onConfirm } = this.props;
    this.registrationLinkInputRef.select();
    document.execCommand('copy');
    onConfirm();
  };

  onLoginAsUser = () => {
    const { adminLoginAsUser, user } = this.props;
    const selectedUser = user.entity;
    adminLoginAsUser(selectedUser.email);
  };
  //#endregion

  //#region rendering
  /* ############## */
  /* VIEW RENDERING */
  /* ############## */
  renderContent = () => {
    const { user } = this.props;
    const userName =
      user.entity.firstName && user.entity.lastName
        ? user.entity.firstName + ' ' + user.entity.lastName
        : user.entity.email;

    switch (this.state.selectedView) {
      case 'transfer':
        return this.renderTransfer(userName);

      case 'remove':
        return this.renderRemove(userName);

      case 'login':
        return this.renderLogin(userName);

      default:
        return this.renderDefault(userName);
    }
  };

  renderTransfer = userName => {
    const { user } = this.props;
    const { teams, teamSelection, role, regions, regionSelection } = this.getValuesFromStateOrProps();
    const isOrphan = (this.state.selectedRegion || regions[0]._id) === 'orphan' || regionSelection === 'orphan';

    return (
      <ModalContentBlock
        title={Localize('form.transfer-user.title.0') + '\n' + userName + '\n' + Localize('form.transfer-user.title.1')}
      >
        <Form>
          <Label label={Localize('region')}>
            <Select
              disabled={this.state.setAdmin > 2}
              onChange={e => this.handleRegionChange(e)}
              value={regionSelection}
            >
              {/* IF disabled, make selection blank */}
              {this.state.selectedRole === 'salesmanager' || this.state.setAdmin > 2 ? (
                <option key="0" value="" disabled={role !== 'salesmanager'} />
              ) : (
                regions &&
                regions.map(function(region, i) {
                  return (
                    <option key={region._id} value={region._id}>
                      {region.name}
                    </option>
                  );
                })
              )};
            </Select>
          </Label>

          <Label label={Localize('team')}>
            <Select disabled={this.state.setAdmin > 1} onChange={e => this.handleTeamChange(e)} value={teamSelection}>
              {/* IF disabled, make selection blank */}
              {this.state.setAdmin > 1 ? (
                <option key="0" value="" />
              ) : (
                teams.map(function(team, i) {
                  return (
                    <option key={team._id} value={team._id}>
                      {team.name}
                    </option>
                  );
                })
              )};
            </Select>
          </Label>

          <Spacer />

          <Label label={Localize('role')}>
            <Select
              disabled={this.state.selectedAdminRole !== '' && this.state.setAdmin > 0}
              onChange={e => this.handleRoleChange(e)}
              value={this.state.selectedRole || user.entity.role}
            >
              <option key="1" value="user">
                {Localize('user.role.user')}
              </option>
              <option key="2" value="assistant">
                {Localize('user.role.assistant')}
              </option>
              <option key="3" value="teamlead">
                {Localize('user.role.teamlead')}
              </option>
              {!isOrphan && (
                <option key="4" value="regionmanager">
                  {Localize('user.role.regionmanager')}
                </option>
              )}
              <option key="5" value="salesmanager">
                {Localize('user.role.salesmanager')}
              </option>
              {/* REMOVED BECAUSE SUPERUSERS CANNOT BE TRANSFERED OR THE ROLE CANNOT BE CHANGED AFTER BECOMING SUPERUSER
              <option key="6" id="superuser" value="Admin">
                Admin
              </option>
               */}
            </Select>
          </Label>

          <Label label={Localize('admin.promote')}>
            <Select onChange={e => this.handleAdminChange(e)} value={this.state.selectedAdminRole || ''}>
              <option key="0" value="" />
              <option key="1" value="teamlead">
                {Localize('user.role.teamlead')}
              </option>
              {!isOrphan && (
                <option key="2" value="regionmanager">
                  {Localize('user.role.regionmanager')}
                </option>
              )}
              <option key="3" value="salesmanager">
                {Localize('user.role.salesmanager')}
              </option>
            </Select>
          </Label>
          <footer>
            <Button
              theme="light"
              onClick={e => {
                this.resetView();
              }}
            >
              {Localize('action.cancel')}
            </Button>
            <Button
              onClick={e => this.confirmTransfer(user)}
              disabled={user.entity.role === 'salesmanager' && regionSelection === (undefined || '')}
            >
              {Localize('action.ok')}
            </Button>
          </footer>
        </Form>
      </ModalContentBlock>
    );
  };

  renderRemove = userName => {
    const { user, onConfirm } = this.props;

    return (
      <ModalContentBlock title={Localize('admin.confirm.delete') + ':\n' + userName}>
        <Form>
          <footer>
            <Button
              theme="light"
              onClick={e => {
                this.resetView();
              }}
            >
              {Localize('action.cancel')}
            </Button>
            <Button
              onClick={e => {
                onConfirm();
                this.confirmDelete(user);
              }}
            >
              {Localize('action.confirm')}
            </Button>
          </footer>
        </Form>
      </ModalContentBlock>
    );
  };

  renderLogin = userName => {
    return (
      <ModalContentBlock title={Localize('admin.confirm.login') + ':\n' + userName}>
        <Form>
          <footer>
            <Button
              theme="light"
              onClick={e => {
                this.resetView();
              }}
            >
              {Localize('action.cancel')}
            </Button>
            <Button onClick={this.onLoginAsUser}>{Localize('action.confirm')}</Button>
          </footer>
        </Form>
      </ModalContentBlock>
    );
  };

  renderDefault = userName => {
    const { user } = this.props;
    return (
      <ModalContentBlock title={Localize('user') + '\n' + userName}>
        <Spacer />

        <Form>
          <Wrapper>
            <ul>
              {user.entity.role !== 'superuser' && (
                <li>
                  <Button onClick={e => this.setState({ selectedView: 'transfer' })}>
                    {Localize('admin.change.role')}
                  </Button>
                </li>
              )}
              {user.entity.role !== 'superuser' && (
                <li>
                  <Button onClick={e => this.setState({ selectedView: 'remove' })}>
                    {Localize('admin.delete.user')}
                  </Button>
                </li>
              )}
              <li>
                <Button onClick={e => this.setState({ selectedView: 'login' })}>{Localize('admin.login')}</Button>
              </li>
              <li style={{ marginBottom: '-2rem' }}>
                <LabelInput
                  name="registrationLink"
                  label="Rekisteröitymislinkki"
                  type="text"
                  onChange={() => false}
                  innerRef={ref => {
                    this.registrationLinkInputRef = ref;
                  }}
                  value={user.registrationLink}
                  readonly="readonly"
                />
              </li>
              <li>
                <Button onClick={this.onCopyRegistrationLink}>{Localize('admin.copy')}</Button>
              </li>
            </ul>
          </Wrapper>

          <Spacer />

          <footer>
            <Button theme="light" onClick={this.onCancelHandler}>
              {Localize('action.close')}
            </Button>
          </footer>
        </Form>
      </ModalContentBlock>
    );
  };
  //#endregion

  //#region helpers
  /* ################### */
  /* HELPERS */
  /* ################### */
  getRoleNumber = role => {
    /* Used to simplyfy the disabling of transfer form selections */
    switch (role) {
      case 'superuser':
        return '0';
      case 'salesmanager':
        return '1';
      case 'regionmanager':
        return '2';
      case 'teamlead':
        return '3';
      case 'assistant':
        return '4';
      case 'user':
        return '5';
      default:
        break;
    }
  };

  resetView = () => {
    this.setState(this.initialState);
  };

  getValuesFromStateOrProps = () => {
    const { user, users } = this.props;
    let channel = null;
    let regions = [];
    /* Component is rendered inside parent render, so check that component is called with user and not just null value */
    if (user) {
      /* Users come from UserListContainer and is composed of all the channels */
      channel = users.find(channel => channel._id === user.entity.channel);
      if (channel) {
        regions = channel.regions;
      } else {
        /* NOTE: UserSearchForm does not return channel id but the whole channel object */
        channel = users.find(channel => channel._id === user.entity.channel._id);
        if (channel) {
          regions = channel.regions;
        } else {
          console.log('ERROR: User has no CHANNEL!?');
        }
      }
    }

    /* Get region & teams + initial selection for team */
    let regionId = this.state.selectedRegion ? this.state.selectedRegion : user.entity.region;
    let hasRegion = regions.find(region => region._id === regionId);
    if (!hasRegion) {
      /* Case where there is regions and orphan teams, this fixes user selection on orphan teams */
      hasRegion = regions.find(region => region._id === 'orphan');
    }
    const region = hasRegion ? hasRegion : regions[0];
    if (!hasRegion) {
      regionId = region._id;
    }
    const regionSelection = this.state.selectedRegion ? this.state.selectedRegion : region ? region._id : '';
    const teamId = this.state.selectedTeam ? this.state.selectedTeam : user.entity.team;
    const teams = region ? region.teams : [];
    const hasTeam = teams.find(team => team._id === teamId);
    const team = hasTeam ? hasTeam : teams[0];
    const teamSelection = team ? team._id : '';
    const role = this.state.selectedRole ? this.state.selectedRole : user.entity.role;
    const admin = this.state.selectedAdminRole ? this.state.selectedAdminRole : ''; //NOTE: admin can be empty

    const obj = {
      regionId,
      regions,
      region,
      teamId,
      teams,
      team,
      teamSelection,
      regionSelection,
      role,
      channel,
      admin,
    };

    return obj;
  };
  //#endregion

  onCancelHandler = () => {
    const { onCancel } = this.props;
    // reset state
    this.setState(this.initialState);
    onCancel();
  };

  render() {
    const { open } = this.props;
    return open ? <CloseableModal onBackdropClick={this.onCancelHandler}>{this.renderContent()}</CloseableModal> : null;
  }
}

export default UserControl;



// WEBPACK FOOTER //
// ./src/modules/user/components/UserControl.js